import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { ReactComponent as BriefcaseIcon } from "feather-icons/dist/icons/briefcase.svg";
import { ReactComponent as MoneyIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import RustyLock from "images/keyservice/rustylock.avif"

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(
  SectionHeading
)`mt-4 font-black text-[#3F62A3] text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Features = tw.div`mt-8 max-w-sm mx-auto md:mx-0`;
const Feature = tw.div`mt-8 flex items-start flex-col md:flex-row`;

const FeatureIconContainer = styled.div`
  ${tw`mx-auto inline-block border border-primary-500 text-center rounded-full p-2 flex-shrink-0`}
  svg {
    ${tw`w-5 h-5 text-primary-500`}
  }
`;

const FeatureText = tw.div`mt-4 md:mt-0 md:ml-4 text-center md:text-left`;
const FeatureHeading = tw.div`font-bold text-lg text-primary-500`;
const FeatureDescription = tw.div`mt-1 text-sm`;

export default ({
  subheading = "Onze expertise",
  heading = (
    <>
      Bij Key Service hebben we het <span tw="text-primary-500">meest bedreven</span> team van slotenmakers.
    </>
  ),
  description = "Als slotenmakers begrijpen wij dat elke situatie uniek is, en daarom passen wij onze expertise aan om aan jouw specifieke beveiligingsbehoeften te voldoen. Of je nu buitengesloten bent, te maken hebt met een defect slot of je deuren wilt upgraden voor extra veiligheid, wij staan klaar om je te helpen. Van het vervangen van sloten tot het installeren van geavanceerde inbraakpreventiesystemen, wij bieden vakmanschap en betrouwbare oplossingen voor jouw veiligheid.",
  features = null,
  textOnLeft = true
}) => {

  const defaultFeatures = [
    {
      Icon: BriefcaseIcon,
      title: "professionaliteit",
      description: "We hebben de beste slotenmakers voor jou specifieke benodigdheden."
    },
    {
      Icon: MoneyIcon,
      title: "betaalbaar",
      description: "We beloven altijd de juiste prijs en kwaliteitsverhouding."
    }
  ];

  if (!features) features = defaultFeatures;

  return (
    <Container id={"expertise"}>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={RustyLock} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <Subheading>{subheading}</Subheading>
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
            <Features>
              {features.map((feature, index) => (
                <Feature key={index}>
                  <FeatureIconContainer>{<feature.Icon />}</FeatureIconContainer>
                  <FeatureText>
                    <FeatureHeading>{feature.title}</FeatureHeading>
                    <FeatureDescription>{feature.description}</FeatureDescription>
                  </FeatureText>
                </Feature>
              ))}
            </Features>
            <div tw="mt-8 text-center md:text-left">
              <a
                  href="/blogs"
                  className="px-8 py-3 lg:mr-10 font-bold rounded bg-yellow-500 text-gray-100 transition duration-300"
              >
                Lees onze blog vol veiligheidstips
              </a>
            </div>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
